import React, { useState } from "react";
import { Link } from "react-router-dom";
import blogData from "../../../data/innerpages/blog/blogData.json";

function Slider() {

  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 8;

  const indexOfLast = currentPage * blogsPerPage;
  const indexOfFirst = indexOfLast - blogsPerPage;
  const currentBlogs = blogData;

  const totalPages = Math.ceil(blogData.length / blogsPerPage);

  return (
    <section className="tc-main-slider-style1">
      <div className="container-fluid">
        <div className="row">

          {/* LEFT SIDE */}
          {/* LEFT SIDE */}
<div className="col-lg-9">

  <div className="row">

    {currentBlogs.map((blog) => (
      <div className="col-lg-4 col-md-6 mb-4 d-flex" key={blog.id}>

        <div className="blog-card">

          <img
            src={blog.image}
            alt={blog.title}
            className="img-fluid blog-img"
          />

          <div className="blog-card-content">

            <p className="blog-date">
              <i className="ti-calendar"></i> {blog.date}
            </p>

            <Link to={`/innerpages/blog/${blog.slug}`}>
              <h3 className="blog-h3">
                {blog.title}
              </h3>
            </Link>

            <p className="descr-text">
              {blog.desc}
            </p>

           <Link
  to={`/innerpages/blog/${blog.slug}`}
  className="read-more-btn"
>
  Read More →
</Link>
          </div>

        </div>

      </div>
    ))}

  </div>

</div>

          {/* RIGHT SIDE */}
          <div className="col-lg-3 right-container-box">

            {/* Recent Posts */}
            <div className="sidebar-box mb-5">
              <h5 className="mb-3">Recent Posts</h5>

              {blogData.slice(0, 3).map((post) => (
                <div className="recent-post d-flex mb-3" key={post.id}>

                  <Link to={post.link}>
                    <img
                      src={post.image}
                      alt={post.title}
                      className="recent-img"
                    />
                  </Link>

                  <div className="ms-3">
                    <Link to={`/innerpages/blog/${post.slug}`}>
                      <h6 className="mb-1">{post.title}</h6>
                    </Link>

                    <p className="date mb-0">{post.date}</p>
                  </div>

                </div>
              ))}
            </div>

            {/* Tags */}
            <div className="sidebar-box">
              <h5 className="mb-3">Tags</h5>

              <div className="tags">
                <span className="tag">Architecture</span>
                <span className="tag">InteriorDesign</span>
                <span className="tag">SustainableDesign</span>
                <span className="tag">ModernArchitecture</span>
                <span className="tag">ConcreteDesign</span>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}

export default Slider;